import css from 'styled-jsx/css';

const styles = css.global`.final-message .img-proposal {
  max-width: 288px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 24px;
}

.final-message .text-title {
  font-family: SantanderHeadline;
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0 0 32px;
  color: #222;
}

.final-message .text-description {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin: 0;
  color: #222;
}

.final-message .text-description.bold {
  font-family: 'SantanderHeadline';
  font-weight: 800;
  margin-bottom: 8px;
  margin-top: 32px;
}

.final-message .next-wrapper-bg {
  background: #f5f9fb;
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 12px;
  margin: 32px 0;
}

.final-message .text-next-container {
  margin-left: 20px;
}

.final-message .text-next {
  font-family: 'SantanderHeadline';
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #222;
  margin-bottom: 32px;
}

.final-message .text-next-item {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin: 0;
  color: #222;
  margin-bottom: 16px;
}

.final-message .text-next-item:last-of-type {
  margin-bottom: 0;
}

.final-message #btn-goto-initial-page {
  margin-top: 32px;
}

.final-message .box-proposal {
  background: #fbfbfb;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 16px;
  margin-top: 24px;
}

.final-message .box-proposal .box-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.final-message .box-proposal .box-row > p {
  font-family: SantanderText;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #444444;
}

.final-message .box-proposal .box-text {
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #444444;
  margin-top: 4px;
  margin-bottom: 24px;
}

.final-message .box-proposal .box-text:last-of-type {
  margin-bottom: 0;
}

@media (min-width: 992px) {
  .final-message {
    /* descontando o padding padrão */
    padding: calc(96px - 40px) 0;
    min-height: 512px;
  }

  .final-message .ctn-home-24 {
    padding-left: 0;
    padding-right: 0;
  }

  .final-message .content-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;
    position: relative;
    overflow: visible;
    gap: 4px;
    transform: translateX(-45px);
  }

  .final-message .content-img {
    max-width: 395px;
    height: auto;
    flex: 1;
  }

  .final-message .img-proposal {
    margin: 0;
    width: 100%;
    max-width: unset;
    transform: translateY(-77px);
  }

  .final-message .text-title {
    color: #222;
    font-size: 40px;
    line-height: 60px;
  }

  .final-message .sn-button.red {
    max-width: 228px;
  }

  .final-message #btn-goto-initial-page {
    margin-top: 56px;
    max-width: 328px;
  }

  .final-message.proposal-failed .content-wrapper {
    gap: 72px;
  }

  .final-message.proposal-failed .img-proposal {
    transform: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .final-message.proposal-approved .text-title {
    margin-bottom: 16px;
  }

  .final-message.proposal-approved .img-proposal {
    transform: translateY(-50px);
  }

  .final-message .content-wrapper {
    gap: 44px;
  }
}
`;

export default styles;